import { forwardRef, useImperativeHandle,  } from 'react'
import VideoQuiz from './components/VideoQuiz';
import VideoProvider from './components/VideoProvider';
import SliceProvider from './components/SliceProvider';
import { useSelector } from 'react-redux';

const Game = forwardRef(function Game({ onAnswer }, ref) {

  const questions = useSelector(state => state.game.questions); 
  const currentQuestion = useSelector(state => questions[state.game.currentIndex]);
  const sequences = currentQuestion.sequences;

  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
      // console.log("animación de entrada")
    },
    animateFail: async () => {
      // console.log("animación de fallo")
    }
  }));

  return (
    <VideoProvider sequences={sequences} >
      <SliceProvider currentQuestion={currentQuestion} >
        <VideoQuiz onAnswer={onAnswer} currentQuestion={currentQuestion} questions={questions} />
      </SliceProvider>
    </VideoProvider>
  )
})

export default Game